<template>
<div>
  <div class="container">
    <!-- container -->
    <h1><small>プロフィール変更</small></h1>
    <div class="section">
      <form class="mb-5" method="post" @submit.prevent="update()">
        <div class="form-group p-3">
          <label>講師番号</label>
          <p class="form-control-static">{{ lecturer_no }}</p>
        </div>
        <div class="form-group p-3">
          <label class="col-form-label">メールアドレス</label>
          <p class="form-control-static">{{ email }}</p>
        </div>
        <div class="form-group p-3">
          <label for="lecturer-name-input" class="col-form-label">氏名<span class="attention">※</span></label>
          <input type="text" class="form-control" id="lecturer-name-input" placeholder="氏名" v-model="name">
          <p class="error-msg" v-if="validation.name">{{ validation.name }}</p>
        </div>
        <div class="form-group p-3">
          <label for="lecturer-furigana-input" class="col-form-label">ふりがな<span class="attention">※</span></label>
          <input type="text" class="form-control" id="lecturer-furigana-input" placeholder="ふりがな" v-model="name_kana">
          <p class="error-msg" v-if="validation.name_kana">{{ validation.name_kana }}</p>
        </div>

        <div class="form-group p-3">
          <label for="date-birth-input" class="col-form-label">生年月日（西暦）<span class="attention">※</span></label>
          <input class="form-control" type="text" id="date-birth-input" placeholder="2017/01/01" v-model="birthday">
          <p class="error-msg" v-if="validation.birthday">{{ validation.birthday }}</p>
        </div>

        <div class="form-group p-3">
          <p>住所</p>
          <label for="zipcode">郵便番号<span class="attention">※</span></label>
          <input type="text" class="form-control mb-3" id="zipcode" aria-required="true" placeholder="103-0013" v-model="zipcode">
          <p class="error-msg" v-if="validation.zipcode">{{ validation.zipcode }}</p>
          <label for="prefecture">都道府県<span class="attention">※</span></label>
          <select class="form-control md-3" id="prefecture" aria-required="true" v-model="prefecture">
            <option value="">選択して下さい</option>
            <option>北海道</option>
            <option>青森県</option>
            <option>岩手県</option>
            <option>宮城県</option>
            <option>秋田県</option>
            <option>山形県</option>
            <option>福島県</option>
            <option>茨城県</option>
            <option>栃木県</option>
            <option>群馬県</option>
            <option>埼玉県</option>
            <option>千葉県</option>
            <option>東京都</option>
            <option>神奈川県</option>
            <option>山梨県</option>
            <option>新潟県</option>
            <option>富山県</option>
            <option>石川県</option>
            <option>福井県</option>
            <option>長野県</option>
            <option>岐阜県</option>
            <option>静岡県</option>
            <option>愛知県</option>
            <option>三重県</option>
            <option>滋賀県</option>
            <option>京都府</option>
            <option>大阪府</option>
            <option>兵庫県</option>
            <option>奈良県</option>
            <option>和歌山県</option>
            <option>鳥取県</option>
            <option>島根県</option>
            <option>岡山県</option>
            <option>広島県</option>
            <option>山口県</option>
            <option>徳島県</option>
            <option>香川県</option>
            <option>愛媛県</option>
            <option>高知県</option>
            <option>福岡県</option>
            <option>佐賀県</option>
            <option>長崎県</option>
            <option>熊本県</option>
            <option>大分県</option>
            <option>宮崎県</option>
            <option>鹿児島県</option>
            <option>沖縄県</option>
          </select>
          <p class="error-msg" v-if="validation.prefecture">{{ validation.prefecture }}</p>
          <label for="Place3">市区郡町村<span class="attention">※</span></label>
          <input type="text" class="form-control mb-3" id="Place3" aria-required="true" placeholder="中央区" v-model="city">
          <p class="error-msg" v-if="validation.city">{{ validation.city }}</p>
          <label for="Place4">町・番地<span class="attention">※</span></label>
          <input type="text" class="form-control mb-3" id="Place4" aria-required="true" placeholder="日本橋人形町2-4-9" v-model="address1">
          <p class="error-msg" v-if="validation.address1">{{ validation.address1 }}</p>
          <label for="Place5">アパート・マンション・ビル名</label>
          <input type="text" class="form-control mb-3" id="Place5" placeholder="双葉ビル802" v-model="address2">
          <p class="error-msg" v-if="validation.address2">{{ validation.address2 }}</p>
        </div>

        <div class="form-group p-3">
          <label for="Tel">電話番号<span class="attention">※</span></label>
          <input type="tel" class="form-control" id="Tel" placeholder="03-6231-0260" v-model="tel">
          <p class="error-msg" v-if="validation.tel">{{ validation.tel }}</p>
        </div>

        <fieldset class="form-group p-3">
          <label>協会ホームページ掲載<span class="attention">※</span></label>
          <div class="form-check">
            <label class="form-check-label">
              <input type="radio" class="form-check-input" name="optionsRadios" id="optionsRadios1" value="true" v-model="published">する
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input type="radio" class="form-check-input" name="optionsRadios" id="optionsRadios2" value="false" v-model="published">しない
            </label>
          </div>
          <p class="error-msg" v-if="validation.published">{{ validation.published }}</p>
        </fieldset>

        <div class="form-group p-3">
          <label for="lecturer-nickname-input" class="col-form-label">講師名（活動名）<span class="attention" v-if="published === 'true'">※</span></label>
          <input type="text" class="form-control" id="lecturer-nickname-input" placeholder="講師名（活動名）" v-model="lecturer_name">
          <p class="error-msg" v-if="validation.lecturer_name">{{ validation.lecturer_name }}</p>
        </div>

        <div class="form-group p-3">
          <label for="lecturer-nickname-furigana-input" class="col-form-label">講師名 ふりがな<span class="attention" v-if="published === 'true'">※</span></label>
          <input type="text" class="form-control" id="lecturer-nickname-furigana-input" placeholder="こうしめい ふりがな" v-model="lecturer_name_kana">
          <p class="error-msg" v-if="validation.lecturer_name_kana">{{ validation.lecturer_name_kana }}</p>
        </div>

        <div class="form-group p-3">
          <label for="lecturer-active-1" class="col-form-label">活動エリア１（市町村区）<span class="attention" v-if="published === 'true'">※</span></label>
          <input type="text" class="form-control" id="lecturer-active-1" placeholder="東京都中央区" v-model="active_area1">
          <p class="error-msg" v-if="validation.active_area1">{{ validation.active_area1 }}</p>
        </div>

        <div class="form-group p-3">
          <label for="lecturer-active-2" class="col-form-label">活動エリア２（市町村区）</label>
          <input type="text" class="form-control" id="lecturer-active-2" placeholder="東京都港区" v-model="active_area2">
          <p class="error-msg" v-if="validation.active_area2">{{ validation.active_area2 }}</p>
        </div>

        <div class="form-group p-3">
          <label for="qualification">取得資格</label>
          <input type="text" class="form-control" id="qualification" placeholder="取得資格１, 取得資格２, 取得資格３" v-model="qualification">
          <p>※ 複数入力する場合は、「, 」で区切って入力して下さい。</p>
          <p class="error-msg" v-if="validation.qualification">{{ validation.qualification }}</p>
        </div>

        <div class="form-group p-3">
          <label for="self-introduction">自己紹介</label>
          <textarea class="form-control" id="self-introduction" aria-required="true" placeholder="講師の自己紹介を記載" rows="6" v-model="introduction"></textarea>
          <p class="error-msg" v-if="validation.introduction">{{ validation.introduction }}</p>
        </div>

        <div class="form-group p-3">
          <label for="start-reason">始めたきっかけ</label>
          <textarea class="form-control" id="start-reason" aria-required="true" placeholder="おひるねアートを始めたきっかけを記載" rows="6" v-model="trigger"></textarea>
          <p class="error-msg" v-if="validation.trigger">{{ validation.trigger }}</p>
        </div>

        <div class="form-group p-3">
          <label for="good-point">やってよかったこと</label>
          <textarea class="form-control" id="good-point" aria-required="true" placeholder="おひるねアートをやってよかったことを記載" rows="6" v-model="good_things"></textarea>
          <p class="error-msg" v-if="validation.good_things">{{ validation.good_things }}</p>
        </div>

        <div class="form-group p-3">
          <label for="HPURL">ホームページURL</label>
          <input type="url" class="form-control" id="HPURL" placeholder="http://www.koushi1.com/" v-model="homepage">
          <p class="error-msg" v-if="validation.homepage">{{ validation.homepage }}</p>
        </div>

        <div class="form-group p-3">
          <label for="FacebookURL">FACEBOOKページ</label>
          <input type="url" class="form-control" id="FacebookURL" placeholder="https://www.facebook.com/koushi1/" v-model="facebook">
          <p class="error-msg" v-if="validation.facebook">{{ validation.facebook }}</p>
        </div>

        <div class="form-group p-3">
          <label for="LineAt">LINE@</label>
          <input type="text" class="form-control" id="LineAt" placeholder="@koushi1" v-model="line">
          <p class="error-msg" v-if="validation.line">{{ validation.line }}</p>
        </div>

        <div class="form-group p-3">
          <label for="Instagram">Instagram</label>
          <input type="text" class="form-control" id="Instagram" placeholder="Koushi1" v-model="instagram">
          <p class="error-msg" v-if="validation.instagram">{{ validation.instagram }}</p>
        </div>

        <div class="form-group p-3">
          <label for="BlogURL">ブログ</label>
          <input type="url" class="form-control" id="BlogURL" placeholder="http://blog.koushi1.com/" v-model="blog">
          <p class="error-msg" v-if="validation.blog">{{ validation.blog }}</p>
        </div>

        <div class="form-group p-3">
          <label for="InputFile">代表作品（2作品アップロード）</label>
          <image-input class="form-control-file" id="InputFile" aria-describedby="fileHelp"
          v-for="index in workImageCount" :key="index"
          @image-changed="workImageChanged(index, $event)"
          :index="index"
          :image="work_images[index-1]"/>
          <small class="form-text text-muted">jpg,png のみ</small>
        </div>

        <div class="form-group p-3">
          <label for="lecturer-status">講師ステータス</label>
          <p class="form-control-static" id="lecturer-status"><lecturer-status :statuses="lecturerStatusText"/></p>
        </div>

        <div class="form-group p-3">
          <label for="ProfileImageFile">プロフィール写真</label>
          <image-input class="form-control-file" id="ProfileImageFile" aria-describedby="fileHelp" index="3" :image="profile_image"
          @image-changed="profileImageChanged($event)"/>
          <small class="form-text text-muted">jpg,png のみ</small>
        </div>

        <div class="btn-group" role="group" aria-label="group">
          <router-link to="/profile" class="btn btn-outline-info btn-lg">キャンセル</router-link>
          <button type="submit" class="btn btn-primary btn-lg" ref="updateButton" :disabled="isDisabled">更新</button>
        </div>
      </form>

    </div>
    <p class="text-right mt-5">
      <router-link to="/mypage">マイページへのリンク</router-link>
    </p>
  </div>
  <simple-modal class="fade" id="modalRenewal" ref="messageModal">
    {{ modalMessage }}
    <button slot="footer" type="button" class="btn btn-primary" data-dismiss="modal" @click="onModalOkClicked()">OK</button>
  </simple-modal>
</div>
</template>

<script>
import ImageInput from 'components/lecturer/ImageInput'
import SimpleModal from 'components/SimpleModal'
import PrefectureSelector from 'components/PrefectureSelector'
import LecturerStatus from 'components/LecturerStatus'
import api from 'api'
import auth from 'auth'
import binder from 'store/lecturer_form/binder'
import util from 'util/common'
import lecturerUtil from 'util/lecturer'
import modal from 'util/modal'
const booleanKeys = [
  'published', 'birthday_publish', 'email_publish', 'homepage_publish',
  'facebook_publish', 'line_publish', 'instagram_publish', 'blog_publish'
]

const defaultBirthday = '1985/01/01'

export default {
  components: {
    LecturerStatus,
    ImageInput,
    SimpleModal,
    PrefectureSelector
  },
  data () {
    return {
      modalMessage: '',
      validation: {},
      scrollAfterValidation: false,
      needLoginModal: false,
      moveToMypage: false,
      isDisabled: false
    }
  },
  created () {
    api.fetchLecturerProfile(this)
    .then(prof => {
      let p = {
        ...prof,
        birthday: prof.birthday !== '' ? prof.birthday : defaultBirthday
      }
      booleanKeys.forEach(k => { p[k] = p[k] ? 'true' : 'false' })
      this.$store.commit('updateLecturerForm', p)
    }).catch(err => {
      if (err.status === 401) {
        api.onAuthRequired(this)
      } else {
        modal.showErrorModal(this, err)
      }
    })
  },
  methods: {
    workImageChanged (index, img) {
      let imgs = [...this.work_images]
      imgs[index - 1] = img
      this.$store.commit('updateLecturerWorkImages', imgs.filter(i => i !== ''))
    },
    profileImageChanged (img) {
      this.$store.commit('updateLecturerProfileImage', img)
    },
    update () {
      this.validation = lecturerUtil.validateLecturerForm(this)
      if (Object.keys(this.validation).length) {
        this.scrollAfterValidation = true
        return
      }

      this.isDisabled = true

      this.modalMessage = '更新中…'
      this.$refs.messageModal.showModal()

      let uploadTasks = this.work_images.map((image, index) =>
        lecturerUtil.imageUploadTask(this,
          { path: 'profile', image: image },
          { mutation: 'updateLecturerWorkImages', index: index }
        )
      )
      uploadTasks.push(lecturerUtil.imageUploadTask(this,
        { path: 'profile', image: this.profile_image },
        { mutation: 'updateLecturerProfileImage' })
      )
      Promise.all(uploadTasks).then(_ => {
        let form = this.$store.state.lecturerForm
        let profile = {
          ...form,
          birthday: util.parseDateToSendAPI(form.birthday),
          work_image1: this.work_images[0] || '',
          work_image2: this.work_images[1] || ''
        }
        delete profile.work_images
        booleanKeys.forEach(k => { profile[k] = profile[k] === 'true' })

        api.updateLecturerProfile(this, profile).then(_ => {
          if (!auth.isProfileUpdated()) {
            auth.updateProfile()
            this.moveToMypage = true
          }
          this.modalMessage = '更新が完了しました。'
          this.needLoginModal = false
          this.isDisabled = false
        }).catch(
          this.onFetchError)
      }).catch(
        this.onFetchError)
    },
    onFetchError (err) {
      if (err.status === 401) {
        this.modalMessage = 'ログイン有効期限が切れました。お手数ですが再度ログインしてください。'
        this.needLoginModal = true
      } else {
        this.modalMessage = '更新に失敗しました。'
        this.needLoginModal = false
      }
      this.isDisabled = false
    },
    onModalOkClicked () {
      this.$refs.messageModal.hideModal()
      if (this.needLoginModal) {
        modal.showLoginModal(this, 'ログイン')
      } else if (this.moveToMypage) {
        this.$router.push('/mypage')
      }
    }
  },
  computed: {
    ...binder,
    lecturerStatusText () {
      return util.lecturerStatusesText(this.lecturer_statuses)
    },
    workImageCount () {
      return Math.min(2, this.work_images.length + 1)
    }
  },
  updated () {
    if (!this.scrollAfterValidation) {
      return
    }
    let el = this.$el.querySelector('p.error-msg')
    if (el) {
      let rect = el.getBoundingClientRect()
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop
      window.scrollTo(0, rect.top + scrollTop - 100) // XXX
    }
    this.scrollAfterValidation = false
  }
}
</script>



// WEBPACK FOOTER //
// Edit.vue?04af33d8